// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/_css-loader@0.27.3@css-loader/index.js?minimize!../../node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0ef98a22\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/_sass-loader@7.1.0@sass-loader/lib/loader.js!../../node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./docp.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/_vue-style-loader@3.1.2@vue-style-loader/lib/addStylesClient.js")("3e6afa44", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/_vue-style-loader@3.1.2@vue-style-loader!./~/_css-loader@0.27.3@css-loader?minimize!./~/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0ef98a22","scoped":true,"hasInlineConfig":false}!./~/_sass-loader@7.1.0@sass-loader/lib/loader.js!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/docp.vue
// module id = 248
// module chunks = 1